// libs
import get from 'lodash/get';
import { FLASH_SALE_TEXT, MEGA_SAVINGS_TEXT, NYKAA_EXCLUSIVE_TEXT } from 'shared/components/SpecialTags/constants';
import { canGoBack } from 'shared/helpers/history';
import { getEpoch } from 'shared/helpers/saleHelper';

export const getProductImages = (productData: any) => get(productData, 'product.productMedia', []);

export const isUserLandingDirectlyOnPDP = () => {
  return !canGoBack();
};

export const getActiveSpecialTagType = (
  specialTagData?: any,
  cartOfferSpecialTag?: any,
  isSaleParticipating?: boolean,
  onSale?: boolean,
  pdpSplTag?: boolean
): string | null | { tag: string | null; time: number | null } => {

  const now = Math.floor(Date.now() / 1000);

  // Valid tag types using constants
  const VALID_TAG_TYPES = [FLASH_SALE_TEXT, MEGA_SAVINGS_TEXT, NYKAA_EXCLUSIVE_TEXT];

  // Helper function to check if tag type is valid
  const isValidTagType = (tagType: string) => VALID_TAG_TYPES.includes(tagType);

  const isValidPriceRuleTag = (tag: any) =>
    tag &&
    Object.keys(tag)?.length > 0 &&
    getEpoch(tag?.epochStart) < now &&
    getEpoch(tag?.epochEnd) > now;

  const isValidCartRuleTag = (tag: any) =>
    tag &&
    Object.keys(tag)?.length > 0 &&
    getEpoch(tag?.epochEnd) > now;

  // Priority 1 → specialTagData
  if (isSaleParticipating && isValidPriceRuleTag(specialTagData) && specialTagData?.type && isValidTagType(specialTagData.type)) {
    if (pdpSplTag) {
      return {
        tag: specialTagData?.type || null,
        time: getEpoch(specialTagData?.epochEnd)
      };
    }
    return specialTagData?.type || null;
  } else if (onSale && isValidCartRuleTag(cartOfferSpecialTag) && cartOfferSpecialTag?.type && isValidTagType(cartOfferSpecialTag.type)) {
    if (pdpSplTag) {
      return {
        tag: cartOfferSpecialTag?.type || null,
        time: getEpoch(cartOfferSpecialTag?.epochEnd)
      };
    }
    return cartOfferSpecialTag?.type || null;
  }

  // No valid tag
  return null;
};

